import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
    MatDatepickerToggle,
    MatDateRangeInput,
    MatDateRangePicker,
    MatEndDate,
    MatStartDate,
} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FilterData, FilterService} from '@app/assetfilter/filter.service';
import {StateService} from '@app/state/state.service';
import {TagPickerComponent} from '@app/tag/tag-picker/tag-picker.component';
import {UserPickerComponent} from '@app/user-picker/user-picker/user-picker.component';
import {filter, map} from 'rxjs/operators';

@Component({
    selector: 'frog-filter-panel',
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.scss'],
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        UserPickerComponent,
        TagPickerComponent,
        MatDateRangeInput,
        MatStartDate,
        MatEndDate,
        MatHint,
        MatDatepickerToggle,
        MatSuffix,
        MatDateRangePicker,
    ],
})
export class FilterPanelComponent implements OnInit {
    public form: FormGroup;

    constructor(
        private filterService: FilterService,
        private stateService: StateService,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.formBuilder.group({
            search: '',
            tags: [],
            users: [],
            startDate: null,
            endDate: null,
        });
    }

    ngOnInit(): void {
        this.stateService.state
            .pipe(
                map((state) => state.filterData),
                filter((filterData) => filterData !== null),
            )
            .subscribe((value) => {
                if (value.dates) {
                    if (value.dates.length == 1) {
                        value['startDate'] = new Date(value.dates[0]);
                        value['endDate'] = new Date();
                    }
                    if (value.dates.length == 2) {
                        value['startDate'] = new Date(value.dates[0]);
                        value['endDate'] = new Date(value.dates[1]);
                    }
                }

                this.form.patchValue(value);
            });
    }

    apply() {
        const value = this.form.value;
        const startDate = value.startDate as Date;
        const endDate = value.endDate as Date;
        const data = new FilterData(value);
        if (data.users !== null) {
            data.users = data.users.map((user) => (Boolean(user['email']) ? user['email'] : user));
        }
        if (data.tags !== null) {
            data.tags = data.tags.map((tag) => (Boolean(tag['name']) ? tag['name'] : tag));
        }

        if (startDate !== null) {
            data.dates = [
                `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()}`,
            ];
            if (endDate !== null) {
                data.dates.push(
                    `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()}`,
                );
            }
        }

        delete data['startDate'];
        delete data['endDate'];

        this.filterService.setFilterData(data);
    }

    clear() {
        this.filterService.clear();
    }
}
